/* Axtlan cinematic layer for the shop (axtlan.mx parity, owner 2026-10-07 "i see no extra fx or toggle for them like in
 * axtlan.mx"). Ported from axtlan.mx site.js (ambient field) and cinematic-surfaces.js, adapted to the Rise sections:
 * 1. Ambient field: 54 embers drifting behind the whole page on a fixed canvas; they swell with the soundtrack
 *    (--audio-energy from the player's analyser). Full experience = animated at 60 fps (30 fps on weak devices),
 *    Low usage = one still frame, Reduce motion = hidden. Pauses while the tab is hidden.
 * 2. Cinematic surfaces: every main section gets the atmosphere + light field layers (grid, rays, motes, horizon) that
 *    follow the pointer; product cards get the animated edge and the glint on hover; section titles get the aurora.
 * 3. Input response: buttons answer a press with the axtlan.mx confirm ring.
 * Everything is decorative (aria-hidden), never blocks clicks and is off under prefers-reduced-motion / forced colors.
 * Driven by <html data-ax-mode> (complete / light / off) and data-ax-theme, see assets/axtlan-experience.js. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var forcedMq = window.matchMedia('(forced-colors: active)');
  var fineMq = window.matchMedia('(hover: hover) and (pointer: fine)');
  var pageHidden = false;
  function mode() { return root.getAttribute('data-ax-mode') || 'complete'; }
  function full() { return mode() === 'complete' && root.getAttribute('data-ax-contrast') !== 'high' && !reducedMq.matches && !forcedMq.matches && !pageHidden && document.visibilityState === 'visible'; }
  function layer(cls) { var s = document.createElement('span'); s.className = cls; s.setAttribute('aria-hidden', 'true'); return s; }

  /* 1. ambient field */
  var canvas = document.querySelector('[data-ax-ambient]'), frame = 0, nextDraw = 0, slow = (navigator.hardwareConcurrency || 8) <= 4;
  var parts = [];
  for (var i = 0; i < 54; i++) parts.push({ x: ((i * 73) % 100) / 100, y: ((i * 41) % 100) / 100, size: .4 + (i % 5) * .22, speed: .000006 + (i % 7) * .0000012, phase: i * .67 });
  function energy() { return parseFloat(getComputedStyle(root).getPropertyValue('--audio-energy')) || 0; }
  function draw(time) {
    frame = 0;
    if (!canvas || mode() === 'off') return;
    var animate = full();
    var interval = 1000 / (slow ? 30 : 60);
    if (animate && time + .5 < nextDraw) { frame = requestAnimationFrame(draw); return; }
    nextDraw = animate ? (nextDraw > 0 && time - nextDraw < interval ? nextDraw + interval : time + interval) : 0;
    var dpr = Math.min(window.devicePixelRatio || 1, mode() === 'light' ? 1 : 1.4);
    var w = Math.round(innerWidth * dpr), h = Math.round(innerHeight * dpr);
    if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
    var ctx = canvas.getContext('2d'); if (!ctx) return;
    ctx.clearRect(0, 0, w, h);
    var e = energy(), t = time || 0, light = root.getAttribute('data-ax-theme') === 'light';
    for (var k = 0; k < parts.length; k++) {
      var p = parts[k];
      var x = (p.x + Math.sin(t * p.speed + p.phase) * .025) * w, y = (p.y + Math.cos(t * p.speed * .7 + p.phase) * .02) * h;
      ctx.fillStyle = light
        ? 'rgba(160,' + Math.round(60 + (p.phase % 50)) + ',20,' + (.14 + e * .1).toFixed(3) + ')'
        : 'rgba(255,' + Math.round(105 + (p.phase % 80)) + ',' + Math.round(45 + (p.phase % 70)) + ',' + (.08 + e * .08).toFixed(3) + ')';
      ctx.beginPath(); ctx.arc(x, y, p.size * dpr * (1 + e * 1.8), 0, Math.PI * 2); ctx.fill();
    }
    if (animate) frame = requestAnimationFrame(draw);
  }
  function restart() { cancelAnimationFrame(frame); frame = 0; nextDraw = 0; if (!pageHidden) frame = requestAnimationFrame(draw); }

  /* 2. cinematic surfaces */
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var scenes = [].slice.call(document.querySelectorAll('main > .shopify-section'));
    var hues = { formation: 27, sirocco: 199, rats: 96 };
    var fhue = (location.pathname.match(/\/collections\/(formation|sirocco|rats)\b/) || [])[1];
    scenes.forEach(function (s) {
      s.classList.add('vfx-scene');
      if (fhue) s.style.setProperty('--fx-hue', hues[fhue]);
      var field = layer('cinematic-lightfield');
      ['cinematic-rays', 'cinematic-motes', 'cinematic-horizon'].forEach(function (c) { field.appendChild(layer(c)); });
      s.insertBefore(field, s.firstChild);
      s.insertBefore(layer('cinematic-atmosphere'), s.firstChild);
    });
    document.querySelectorAll('.product-card-wrapper .card, .ax-perks__tier, .rotation-today__card, .ax-dir__col').forEach(function (c) {
      c.classList.add('vfx-surface');
      if (!c.querySelector(':scope > .cinematic-edge')) c.appendChild(layer('cinematic-edge'));
    });
    document.querySelectorAll('main h2.title, main .ax-section-title, main .card__heading').forEach(function (t) { t.classList.add('vfx-title'); });

    var targets = [].slice.call(document.querySelectorAll('.vfx-scene, .vfx-surface'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-vfx-active', e.isIntersecting); }); }, { rootMargin: '18% 0px 18% 0px', threshold: .01 });
      targets.forEach(function (t) { io.observe(t); });
    } else targets.forEach(function (t) { t.classList.add('is-vfx-active'); });

    /* pointer light: follows the mouse inside a section, eased like axtlan.mx */
    var pend = 0, scene = null, goal = null, cur = { x: 50, y: 46 }, lt = 0, n = 0;
    function reset() {
      if (pend) cancelAnimationFrame(pend); pend = 0; lt = 0; n = 0;
      if (scene) ['--cinematic-pointer-x', '--cinematic-pointer-y', '--fx-drift-x', '--fx-drift-y'].forEach(function (v) { scene.style.removeProperty(v); });
      scene = null; goal = null; cur = { x: 50, y: 46 };
    }
    function paint(time) {
      pend = 0;
      if (!scene || !goal || !full() || !fineMq.matches) { reset(); return; }
      var dt = lt ? Math.min(50, Math.max(0, time - lt)) : 16.67; lt = time;
      var k = 1 - Math.exp(-dt / 85);
      cur.x += (goal.x - cur.x) * k; cur.y += (goal.y - cur.y) * k; n++;
      var done = Math.abs(goal.x - cur.x) + Math.abs(goal.y - cur.y) < .08 || n >= 48;
      if (done) cur = { x: goal.x, y: goal.y };
      scene.style.setProperty('--cinematic-pointer-x', cur.x.toFixed(2) + '%');
      scene.style.setProperty('--cinematic-pointer-y', cur.y.toFixed(2) + '%');
      scene.style.setProperty('--fx-drift-x', ((cur.x - 50) * .16).toFixed(2) + 'px');
      scene.style.setProperty('--fx-drift-y', ((cur.y - 46) * .1).toFixed(2) + 'px');
      if (!done) pend = requestAnimationFrame(paint); else lt = 0;
    }
    scenes.forEach(function (s) {
      s.addEventListener('pointermove', function (e) {
        if (!full() || !fineMq.matches || e.pointerType === 'touch') return;
        if (scene !== s) { reset(); scene = s; }
        var b = s.getBoundingClientRect(); if (!b.width || !b.height) return;
        goal = { x: Math.max(0, Math.min(100, (e.clientX - b.left) / b.width * 100)), y: Math.max(0, Math.min(100, (e.clientY - b.top) / b.height * 100)) };
        n = 0; if (!pend) pend = requestAnimationFrame(paint);
      }, { passive: true });
      s.addEventListener('pointerleave', function () { if (scene === s) reset(); }, { passive: true });
    });

    /* 3. input response on buttons (links keep Rise's whole-card click area, so they are left alone) */
    var sel = 'main .button, main button, .ax-exp button, .ax-xp summary, .ax-xp label';
    document.querySelectorAll(sel).forEach(function (b) {
      if (b.matches(':disabled') || b.querySelector(':scope > .input-response-layer')) return;
      b.setAttribute('data-input-response', b.matches('summary, label, [aria-pressed], [aria-expanded]') ? 'toggle' : 'press');
      b.appendChild(layer('input-response-layer'));
    });
    function target(t) { return t && t.closest ? t.closest('[data-input-response]') : null; }
    var timers = new WeakMap();
    document.addEventListener('pointerdown', function (e) { var t = target(e.target); if (t) t.classList.add('is-input-pressing'); }, { passive: true });
    document.addEventListener('pointerup', function (e) {
      document.querySelectorAll('.is-input-pressing').forEach(function (t) { t.classList.remove('is-input-pressing'); });
      var t = target(e.target); if (!t) return;
      clearTimeout(timers.get(t)); t.classList.add('is-input-confirmed');
      timers.set(t, setTimeout(function () { t.classList.remove('is-input-confirmed'); }, 620));
    }, { passive: true });
    document.addEventListener('pointercancel', function () { document.querySelectorAll('.is-input-pressing').forEach(function (t) { t.classList.remove('is-input-pressing'); }); }, { passive: true });

    /* 4. symbol wave (axtlan.mx site.js, owner 2026-10-07 "the shop doesnt have a symbol font > text animation system like
       axtlan.mx"): short labels are split into graphemes; every ~7 s a wave turns them into Axtlan Detector symbols (codes
       from the alphabet below) with a light ray sweeping across, then they resolve back to the readable text. The text stays
       real text for screen readers and search engines; only labels on screen take part. */
    var ALPHA = '0123456789AXTLANKREKSUN', seg = null;
    try { seg = new Intl.Segmenter(root.lang || undefined, { granularity: 'grapheme' }); } catch (e) { seg = null; }
    function graphemes(v) { return seg ? [].map.call(Array.from(seg.segment(v)), function (p) { return p.segment; }) : Array.from(v); }
    var letter = /[\p{L}\p{N}]/u;
    function prepare(t, idx) {
      if (t.childElementCount || t.closest('[aria-hidden="true"], .visually-hidden')) return false;
      var text = (t.textContent || '').trim();
      if (!/\p{L}/u.test(text) || text.length > 48) return false;
      // the wave lives in an inner span so the label keeps its own display and its ::before / ::after decorations
      var host = document.createElement('span'); host.className = 'symbol-wave-target'; host.setAttribute('data-symbol-wave-text', text);
      t.textContent = '';
      var readable = document.createElement('span'); readable.className = 'symbol-wave-readable';
      var gs = graphemes(text), count = gs.filter(function (g) { return letter.test(g); }).length, gi = 0;
      gs.forEach(function (g) {
        if (!letter.test(g)) { readable.appendChild(document.createTextNode(g)); return; }
        var unit = document.createElement('span'), loc = document.createElement('span');
        unit.className = 'symbol-wave-unit'; unit.setAttribute('data-symbol-code', ALPHA[(idx * 17 + gi * 11) % ALPHA.length]);
        unit.style.setProperty('--symbol-wave-step', count > 1 ? Math.round(gi * 24 / (count - 1)) : 0);
        loc.className = 'symbol-wave-grapheme'; loc.textContent = g; unit.appendChild(loc); readable.appendChild(unit); gi++;
      });
      host.appendChild(readable); host.appendChild(layer('symbol-wave-rays')); t.appendChild(host);
      return host;
    }
    // Speclang (2026-10-07): the symbol wave needs the Axtlan Detector font, which is Axtlan-only, so it runs only on
    // elements that opt in with data-ax-symbol-wave (none in the Speclang theme). Axtlan selector list kept in AXTLAN-SKIN-SRC.
    var waveSel = '[data-ax-symbol-wave]';
    var waves = [];
    [].forEach.call(document.querySelectorAll(waveSel), function (t, i) { var h = prepare(t, i); if (h) waves.push(h); });
    var waveSeen = new Set(), waveTimer = 0, waveSettle = 0, waveOn = false;
    if ('IntersectionObserver' in window) {
      var wio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) waveSeen.add(e.target); else waveSeen.delete(e.target); }); });
      waves.forEach(function (w) { wio.observe(w); });
    } else waves.forEach(function (w) { waveSeen.add(w); });
    function waveRun() {
      if (!waveOn) return;
      root.setAttribute('data-symbol-wave', 'active');
      waves.forEach(function (w) { w.classList.toggle('is-wave-active', waveSeen.has(w)); });
      clearTimeout(waveSettle);
      waveSettle = setTimeout(function () {
        root.removeAttribute('data-symbol-wave'); waves.forEach(function (w) { w.classList.remove('is-wave-active'); });
        if (waveOn) waveTimer = setTimeout(waveRun, 5400);
      }, 1800);
    }
    function waveSync() {
      if (!full() || !waves.length) { waveOn = false; clearTimeout(waveTimer); clearTimeout(waveSettle); root.removeAttribute('data-symbol-wave'); return; }
      if (waveOn) return; waveOn = true; waveTimer = setTimeout(waveRun, 720);
    }

    function sync() { root.toggleAttribute('data-ax-fx-suspended', !full()); if (!full()) reset(); restart(); waveSync(); }
    document.addEventListener('ax:mode', sync); document.addEventListener('ax:prefs', sync);
    [reducedMq, forcedMq, fineMq].forEach(function (m) { if (m.addEventListener) m.addEventListener('change', sync); });
    document.addEventListener('visibilitychange', function () { pageHidden = document.visibilityState !== 'visible'; sync(); });
    window.addEventListener('pagehide', function () { pageHidden = true; sync(); });
    window.addEventListener('pageshow', function () { pageHidden = false; sync(); });
    window.addEventListener('resize', function () { if (!full()) restart(); }, { passive: true });
    sync();
  });
})();
